var map = {
	"./3dots.svg": 22863,
	"./admin.svg": 35071,
	"./american-express.svg": 4962,
	"./arrow-down.svg": 62165,
	"./arrow-left.svg": 61982,
	"./arrow-right.svg": 31288,
	"./arrow-up.svg": 17039,
	"./audio.svg": 39846,
	"./book.svg": 3097,
	"./calendar.svg": 37215,
	"./check.svg": 81327,
	"./classroom.svg": 55555,
	"./clock.svg": 9550,
	"./company.svg": 1176,
	"./courses.svg": 37099,
	"./details.svg": 73381,
	"./diamond.svg": 48945,
	"./discover.svg": 9985,
	"./document.svg": 80275,
	"./download.svg": 72538,
	"./events.svg": 97718,
	"./grad-cap.svg": 75178,
	"./grid.svg": 40738,
	"./history.svg": 79243,
	"./home.svg": 67691,
	"./image.svg": 69205,
	"./list.svg": 33052,
	"./loading.svg": 53029,
	"./mail.svg": 86759,
	"./mastercard.svg": 55361,
	"./menu-arrow-down.svg": 27435,
	"./mlc-stacked.svg": 20915,
	"./mlc.svg": 71178,
	"./online.svg": 52702,
	"./plus.svg": 98886,
	"./radio-bg.svg": 3839,
	"./radio.svg": 84230,
	"./remove.svg": 88881,
	"./search.svg": 19127,
	"./shopping-cart.svg": 78647,
	"./star-empty.svg": 89760,
	"./star-filled.svg": 57813,
	"./star-half.svg": 25896,
	"./star.svg": 85567,
	"./trainer.svg": 2469,
	"./training.svg": 79483,
	"./user.svg": 28958,
	"./video-circle.svg": 61781,
	"./video.svg": 70994,
	"./video2.svg": 58426,
	"./visa.svg": 59326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80619;